// extracted by mini-css-extract-plugin
export default {"loading_fullpage":"styles_loading_fullpage__qIUZf","open":"styles_open__NaOHJ"};